import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startClickTracking, trackPageView } from '@/lib/analytics';

// Não mostra nada na tela. Avisa o Google Analytics a cada página visitada
// e liga a contagem de cliques em Reservar, WhatsApp, telefone e e-mail.
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => startClickTracking(), []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default PageViewTracker;
